<template>
  <HeaderComponent></HeaderComponent>

  <main class="main-content">
    <router-view></router-view>
  </main>
</template>

<script>
import HeaderComponent from '@/components/common/Header.vue'

export default {
  name: 'App',
  components: {
    HeaderComponent,
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
}

/* Responsive padding for header space */
.main-content {
  padding-top: 100px; /* Mobile default */
}

@media (min-width: 640px) {
  .main-content {
    padding-top: 120px;
  }
}

@media (min-width: 768px) {
  .main-content {
    padding-top: 140px;
  }
}

@media (min-width: 1024px) {
  .main-content {
    padding-top: 170px;
  }
}
</style>
